/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyOutput
 */
export interface CompanyOutput {
    /**
     * 
     * @type {number}
     * @memberof CompanyOutput
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOutput
     */
    companyName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOutput
     */
    companyHojinNo: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOutput
     */
    companyAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOutput
     */
    companyGln: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOutput
     */
    businessCategory: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOutput
     */
    businessCategoryName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOutput
     */
    tenantId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyOutput
     */
    deleteFlg: boolean | null;
}

/**
 * Check if a given object implements the CompanyOutput interface.
 */
export function instanceOfCompanyOutput(value: object): value is CompanyOutput {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('companyHojinNo' in value) || value['companyHojinNo'] === undefined) return false;
    if (!('companyAddress' in value) || value['companyAddress'] === undefined) return false;
    if (!('companyGln' in value) || value['companyGln'] === undefined) return false;
    if (!('businessCategory' in value) || value['businessCategory'] === undefined) return false;
    if (!('businessCategoryName' in value) || value['businessCategoryName'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    return true;
}

export function CompanyOutputFromJSON(json: any): CompanyOutput {
    return CompanyOutputFromJSONTyped(json, false);
}

export function CompanyOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'companyHojinNo': json['company_hojin_no'],
        'companyAddress': json['company_address'],
        'companyGln': json['company_gln'],
        'businessCategory': json['business_category'],
        'businessCategoryName': json['business_category_name'],
        'tenantId': json['tenant_id'],
        'deleteFlg': json['delete_flg'],
    };
}

export function CompanyOutputToJSON(json: any): CompanyOutput {
    return CompanyOutputToJSONTyped(json, false);
}

export function CompanyOutputToJSONTyped(value?: CompanyOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'company_hojin_no': value['companyHojinNo'],
        'company_address': value['companyAddress'],
        'company_gln': value['companyGln'],
        'business_category': value['businessCategory'],
        'business_category_name': value['businessCategoryName'],
        'tenant_id': value['tenantId'],
        'delete_flg': value['deleteFlg'],
    };
}

